import type { App } from 'vue'

export default {
  install: (app: App, options: any) => {
    // 在这里编写插件代码
  },
}
